import {List, Map} from 'immutable';
import {FETCH_GROOMER_PLANNING} from './actions';
import {CHANGE_SKIRESORT} from './../global/actions';
import {LOGOUT} from './../user/actions';

import {Status} from '../_commons/const';

const initialState = Map();

export default function (state = initialState, {type, groomer, month, year, items}) {
  if (!groomer) {
    return state;
  }
  let key = `${groomer.id}.${year}.${month}`;
  switch (type) {
    case FETCH_GROOMER_PLANNING.do:
      return state.set(key, Status.LOADING);
    case FETCH_GROOMER_PLANNING.success:
      return state.set(key, List(items));
    case FETCH_GROOMER_PLANNING.failure:
      return state.set(key, Status.FAILURE);
    case CHANGE_SKIRESORT:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/planning/reducer.js